import * as passwordInput from '@zag-js/password-input';
import { normalizeProps, useMachine } from 'zag-ripple';
import { track } from 'ripple';
import { Eye, EyeOff } from 'lucide-ripple';

export component PasswordInput() {
	let service = useMachine(passwordInput.machine, {
		id: 'password-input',
	});
	let api = track(() => passwordInput.connect(service, normalizeProps));

	<div {...@api.getRootProps()}>
		<label {...@api.getLabelProps()}>{"Password"}</label>
		<div {...@api.getControlProps()}>
			<input {...@api.getInputProps()} />
			<button {...@api.getVisibilityTriggerProps()}>
				<span {...@api.getIndicatorProps()}>
					if (@api.visible) {
						<Eye />
					} else {
						<EyeOff />
					}
				</span>
			</button>
		</div>
	</div>
}
